import * as React from "react";

interface DebugProps {
  obj: unknown;
}

export function Debug(props: DebugProps): React.ReactElement {
  return <pre>{JSON.stringify(props.obj, null, 2)}</pre>;
}
